<template>
    <div class="a-vg-c--control">
        <button class="a-vg-c--control__button" @click="moneyDec()">-</button>
        <div class="input-field">
            <label for="input">{{$t('vdog_bet')}}:</label>
              <currency-input
              :allow-negative="false"
              :value-range="getValueRange()"
              :auto-decimal-mode="true"
              :currency="null"
              :locale="getLanguageCodeForNumbers()"
              v-model='money'/>
        </div>
        <button class="a-vg-c--control__button" @click="moneyInc()">+</button>
    </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'

import generalMenuSound from '../../../assets/audio/general_menu.mp3'
import vuexStore from '../../../store/vuexStore'

export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    step: {
      type: Number,
      required: true
    },
    minValue: {
      type: Number,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
    currentMoney: {
      type: Number,
      required: true
    },
    minPayIn: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      money: this.minPayIn,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  watch: {
    money: function (val) {
      if (!val) {
        this.money = 0
      }
      if (val < this.minValue) {
        this.$emit('onDecrementMin')
      }
      if (val > this.maxValue) {
        this.$emit('onIncrementMax')
      }
      this.$emit('input', val || 0)
    },
    currentMoney: function (val) {
      if (val > 1000000) {
        setTimeout(() => { this.money = 1000000 })
      } else {
        this.money = val
      }
    }
  },
  mounted: function () {
    if (this.minValue > this.money) {
      this.money = this.minValue
    }
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    getValueRange () {
      return {
        'min': this.minValue,
        'max': this.maxValue
      }
    },
    canDecrement: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(generalMenuSound)
        audio.play()
      }
      return this.minValue <= (this.money - this.step)
    },
    canIncrement: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(generalMenuSound)
        audio.play()
      }
      return this.maxValue >= (this.money + this.step)
    },
    moneyDec: function () {
      if (this.canDecrement()) {
        this.money -= this.step
      } else {
        this.money = this.minValue
        this.$emit('onDecrementMin')
      }
    },
    moneyInc: function () {
      if (this.canIncrement()) {
        this.money += this.step
      } else {
        this.money = this.maxValue
        this.$emit('onIncrementMax')
      }
    }
  }
}
</script>
